"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSound = require("cccisd-sound");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReadHtml = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(ReadHtml, _React$Component);
  function ReadHtml(props) {
    var _this;
    _classCallCheck(this, ReadHtml);
    _this = _callSuper(this, ReadHtml, [props]);
    _defineProperty(_assertThisInitialized(_this), "clearTasks", function () {
      _this.timeouts.forEach(function (timeout) {
        return clearTimeout(timeout);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "play", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, accommodations, setParameters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, accommodations = _this$props.accommodations, setParameters = _this$props.setParameters; // Start playing
            _context.next = 3;
            return (0, _cccisdSound.play)({
              url: _this.props.audio.url,
              onEnd: _this.stopped,
              onStop: _this.stopped
            });
          case 3:
            _this.sound = _context.sent;
            if (_this.mounted) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            // Set playing state
            _this.setState({
              isPlaying: true
            });
            if (accommodations.highlighting && _this._getTimings().length > 0) {
              _this._startHighlighting();
            }
            if (accommodations.masking && _this.props.allowMasking) {
              _this.setState({
                masked: false
              });
            }
            if (setParameters) {
              setParameters({
                isTalking: true
              });
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "stop", function () {
      if (_this.sound) {
        // Stop playing
        _this.sound.stop();

        // Set stopping state
        _this.setState({
          isPlaying: false
        });
        if (_this.props.setParameters) {
          _this.props.setParameters({
            isTalking: false
          });
        }
      }
      if (_this.resolveAutoplayPromise) {
        setTimeout(_this.resolveAutoplayPromise, 500);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "stopped", function () {
      _this.stop();
      if (_this.props.onEnded) {
        _this.props.onEnded();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "replay", function () {
      if (!_this.state.isPlaying && _this.props.clickplay) {
        _this.play();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_startHighlighting", function () {
      _this.startTime = Date.now();
      _this._highlightTimeout();
    });
    _defineProperty(_assertThisInitialized(_this), "_highlightTimeout", function () {
      var timeDiff = Date.now() - _this.startTime;
      _this._updateCurrentWord(timeDiff);
      var nextTimeout = _this._getNextBoundary(timeDiff);
      if (nextTimeout) {
        _this.timeouts.push(setTimeout(_this._highlightTimeout, nextTimeout - timeDiff + 1));
      } else {
        _this._stopHighlighting();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_stopHighlighting", function () {
      _this.setState({
        currentWord: -1
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getTimings", function () {
      var timings = _this.props.audio.wordTimings || [];

      // Sanitize to numbers
      for (var i = 0; i < timings.length; i++) {
        timings[i].start *= 1;
        timings[i].end *= 1;
      }
      return timings;
    });
    _defineProperty(_assertThisInitialized(_this), "_markUpTranscript", function () {
      var unhighlightedClass = _this.props.unhighlightedClass || _style["default"].unhighlighted;
      _this.markedUpTranscript = _this.props.transcript;

      // Convert &nbsp; to spaces
      var nbspRE = new RegExp('&nbsp;', 'ig');
      _this.markedUpTranscript = _this.markedUpTranscript.replace(nbspRE, ' ');

      // Wrap words (that aren't in tags) with unhighlighted word span
      var wordRE = new RegExp('([^\\s>]+(?![^<]*>))', 'ig');
      _this.markedUpTranscript = _this.markedUpTranscript.replace(wordRE, '<span ' + ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '">$1</span>');
    });
    _defineProperty(_assertThisInitialized(_this), "_sortUnique", function (arr) {
      arr = arr.sort(function (a, b) {
        return a * 1 - b * 1;
      });
      var ret = [arr[0]];
      for (var i = 1; i < arr.length; i++) {
        if (arr[i - 1] !== arr[i]) {
          ret.push(arr[i]);
        }
      }
      return ret;
    });
    _defineProperty(_assertThisInitialized(_this), "_setupTimingsBoundaries", function () {
      var boundaries = [];
      var timings = _this._getTimings();
      timings.forEach(function (word) {
        boundaries.push(word.start);
        boundaries.push(word.end);
      });
      _this.timingsBoundaries = _this._sortUnique(boundaries);
    });
    _defineProperty(_assertThisInitialized(_this), "_getNextBoundary", function (currentOffset) {
      for (var i = 0; i < _this.timingsBoundaries.length; i++) {
        var boundary = _this.timingsBoundaries[i];
        if (boundary > currentOffset) {
          return boundary;
        }
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "_findCurrentWord", function (currentOffset) {
      var timings = _this._getTimings();
      for (var i = 0; i < timings.length; i++) {
        if (timings[i].start <= currentOffset && timings[i].end >= currentOffset) {
          return i + 1;
        }
      }
      return -1;
    });
    _defineProperty(_assertThisInitialized(_this), "_updateCurrentWord", function (currentOffset) {
      var currentWord = _this._findCurrentWord(currentOffset);
      if (currentWord !== _this.state.currentWord) {
        _this.setState({
          currentWord: currentWord
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getTranscript", function () {
      var currentWord = _this.state.currentWord;
      var highlightedClass = _this.props.highlightedClass || _style["default"].highlighted;
      var unhighlightedClass = _this.props.unhighlightedClass || _style["default"].unhighlighted;
      var transcript = _this.markedUpTranscript;

      // unhighlight everything
      var highlightedRE = new RegExp(ReadHtml.wordIdentifier + ' class="' + highlightedClass + '"', 'ig');
      transcript = transcript.replace(highlightedRE, ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '"');
      var nth = 0;

      // highlight current word if there is one
      if (currentWord >= 1) {
        var unhighlightedRE = new RegExp(ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '"', 'ig');
        var highlightReplace = ReadHtml.wordIdentifier + ' class="' + highlightedClass + '"';
        transcript = transcript.replace(unhighlightedRE, function (match) {
          return ++nth === currentWord ? highlightReplace : match;
        });
      }
      return transcript;
    });
    _defineProperty(_assertThisInitialized(_this), "_showPlayButton", function () {
      return !!(_this.props.audio.url && _this.props.showPlayButton);
    });
    _this.timeouts = [];
    _this.startTime = 0;
    _this.markedUpTranscript = '';
    _this.timingsBoundaries = [];
    _this.state = {
      masked: false,
      currentWord: -1,
      isPlaying: false
    };
    return _this;
  }
  _createClass(ReadHtml, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        accommodations = _this$props2.accommodations,
        registerAction = _this$props2.registerAction;
      this.mounted = true;
      if (accommodations.masking && this.props.allowMasking) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          masked: true
        });
      }
      if (registerAction) {
        var action = this.getAction();
        registerAction(action);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.sound) {
        this.sound.off();
        this.sound.stop();
      }
      this.clearTasks();
      if (this.rejectAutoplayPromise) {
        this.rejectAutoplayPromise();
      }
    }
  }, {
    key: "getAction",
    value: function getAction() {
      var $this = this;
      var accommodations = this.props.accommodations;
      return {
        play: function play() {
          return new Promise(function (resolve, reject) {
            $this.rejectAutoplayPromise = reject;
            $this.resolveAutoplayPromise = resolve;
            $this.play();
          });
        },
        stop: function stop() {
          $this.stop();
        },
        autoplay: !!(accommodations.autoplayQuestions || accommodations.autoplayChoices)
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.audio.wordTimings) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          onClick: this.replay,
          className: _style["default"].playable
        }, this.props.reactContent);
      }
      this._markUpTranscript();
      this._setupTimingsBoundaries();
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: this._showPlayButton() ? _style["default"].wrapper : ''
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].textWrapper,
        dangerouslySetInnerHTML: {
          __html: this._getTranscript()
        },
        onClick: this.replay
      }), this._showPlayButton() && /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].playButton + ' btn btn-default btn-xs',
        onClick: this.play
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-volume-up"
      })), this.state.masked && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].maskedContainer
      }));
    }
  }]);
  return ReadHtml;
}(_react["default"].Component);
_defineProperty(ReadHtml, "propTypes", {
  transcript: _propTypes["default"].string.isRequired,
  reactContent: _propTypes["default"].object.isRequired,
  audio: _propTypes["default"].object,
  clickplay: _propTypes["default"].bool,
  accommodations: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  allowMasking: _propTypes["default"].bool,
  showPlayButton: _propTypes["default"].bool,
  highlightedClass: _propTypes["default"].string,
  unhighlightedClass: _propTypes["default"].string
});
_defineProperty(ReadHtml, "defaultProps", {
  clickplay: false,
  accommodations: {},
  registerAction: null,
  onEnded: null,
  allowMasking: false,
  showPlayButton: false,
  highlightedClass: null,
  unhighlightedClass: null
});
// Something we can stash in HTML markup and be pretty sure it's a ReadHtml word
_defineProperty(ReadHtml, "wordIdentifier", 'data-readhtml="1"');